"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTreeParameterFactoryFromJS = exports.BaseTreeParameterFactory = void 0;
const core_1 = require("@bimser/core");
const immutable_1 = require("immutable");
exports.BaseTreeParameterFactory = (0, immutable_1.Record)({
    caption: '',
    isActive: true,
    isRequired: true,
    key: '',
    value: null,
    valueType: null,
    guid: (0, core_1.createGuid)(),
    children: (0, immutable_1.List)()
});
const BaseTreeParameterFactoryFromJS = function (data) {
    return (0, exports.BaseTreeParameterFactory)({
        caption: data.caption,
        guid: data.guid,
        isActive: data.isActive,
        isRequired: data.isRequired,
        key: data.key,
        value: data.value,
        valueType: data.valueType,
        children: (0, immutable_1.List)(data.children ? data.children.map(i => (0, exports.BaseTreeParameterFactoryFromJS)(i)) : [])
    });
};
exports.BaseTreeParameterFactoryFromJS = BaseTreeParameterFactoryFromJS;
//# sourceMappingURL=IBaseTreeParameter.js.map